import classNames from 'classnames'
import * as PropTypes from 'prop-types'
import { useAlert } from 'features/dialog/Alert'
import Button from 'components/form/Button'
import { useSelector } from 'react-redux'
import { BizChannelTypes } from '../Codes'

export const TalkChannelList = ({
  kakaoTalkChannels,
  handleToggleChannel,
  isEditable,
  error,
  changeLayoutClass = true,
}) => {
  const { bizChannelType } = useSelector(state => state.channel.channelAdd)
  const [ChannelLimitedAlert, showChannelLimitedAlert] =
    useAlert(changeLayoutClass)
  const max = bizChannelType === BizChannelTypes.TALK_CHANNEL ? 1 : 2
  const handleRegisterClick = kakaoTalkChannel => () => {
    const selectedCount = kakaoTalkChannels.filter(
      item => item.isSelected
    ).length
    if (!kakaoTalkChannel.isSelected && selectedCount >= max) {
      showChannelLimitedAlert()
    } else {
      handleToggleChannel(kakaoTalkChannel.uuid)
    }
  }

  return (
    <ul
      className={classNames('list_bizch', { in_error: error })}
      style={{ minHeight: 100 }}>
      <ChannelLimitedAlert>
        카카오톡 채널은 최대 {max}개까지 선택 가능합니다.
      </ChannelLimitedAlert>
      {kakaoTalkChannels.map(kakaoTalkChannel => (
        <li
          key={kakaoTalkChannel.uuid}
          className={classNames({ on: kakaoTalkChannel.isSelected })}>
          <div className="opt_bizch">
            <span className="opt_img">
              <span
                className="img_thumb"
                style={{ backgroundImage: `url(${kakaoTalkChannel.imgURL})` }}
              />
            </span>
            {kakaoTalkChannel.name}
          </div>
          <Button
            tag="a"
            size="small"
            disabled={!isEditable}
            onClick={handleRegisterClick(kakaoTalkChannel)}>
            {kakaoTalkChannel.isSelected ? '등록해제' : '등록'}
          </Button>
        </li>
      ))}
    </ul>
  )
}

TalkChannelList.propTypes = {
  kakaoTalkChannels: PropTypes.arrayOf(PropTypes.object),
  handleToggleChannel: PropTypes.func,
  isEditable: PropTypes.bool,
  error: PropTypes.string,
  changeLayoutClass: PropTypes.bool,
}
